import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PageType } from './dto/types';
import { AuthBackendService } from '../../auth/service/auth-backend.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./entrance-group.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  private destroyStream = new Subject<void>();

  page: PageType = 'login';
  previousPage: PageType = 'home';
  isDetailsFieldShown = false;

  requestDemoForm = new UntypedFormGroup({
    name: new UntypedFormControl('', [Validators.required]),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    topic: new UntypedFormControl('', [Validators.required]),
    details: new UntypedFormControl(''),
  });

  constructor(
    private auth: AuthBackendService,
    private router: Router,
  ) {

  }

  ngOnInit(): void {
    this.auth.getMaintenance().then((isMaintenance) => {
      if (isMaintenance) {
        this.router.navigate(['/maintenance']);
      }
    });
    this.requestDemoForm.get('topic').valueChanges
      .pipe(takeUntil(this.destroyStream))
      .subscribe(() => {
        this.onTopicUpdate();
      });
  }

  ngOnDestroy(): void {
    this.destroyStream.next();
    this.destroyStream.complete();
  }

  changePage(page: PageType): void {
    this.previousPage = this.page;
    this.page = page;
  }

  private onTopicUpdate(): void {
    const topic = this.requestDemoForm.get('topic').value as string;
    this.isDetailsFieldShown = topic === 'Other';
    if (!this.isDetailsFieldShown) {
      this.requestDemoForm.get('details').setValue('');
    }
  }
}
